// extracted by mini-css-extract-plugin
export default {"list":"list_list__t2tIq","header":"list_header__+Hx2h","input":"list_input__6nSn5","cards":"list_cards__OlVpk","buttonActions":"list_buttonActions__w-9jw"};